import Header from '../app/components/header/Header';

type UnauthenticatedLayoutProps = {
  children: React.ReactNode;
};

const UnauthenticatedLayout = ({ children }: UnauthenticatedLayoutProps) => {
  return (
    <div className='min-h-screen'>
      <Header />
      {children}
    </div>
  );
};

export default UnauthenticatedLayout;
